// preact
import { h, Fragment } from 'preact';
import { useEffect } from 'preact/hooks';

// components
import ProductForm from './product-form';
import BundleForm from './product-bundle-form';

// hooks
import useCustomizerStyleModal from '../../hooks/useCustomizerStyleModal';

// ProductDetail component
const ProductDetail = (props) => {
  const {
    title,
    metafields: { category = '', linkedCollection = '' },
    yotpo: {
      starRating: { instanceID: starRatingID },
    },
  } = props.product;

  const { openCustomizerStyleModal } = useCustomizerStyleModal();

  useEffect(() => {
    // Yotpo widgets are loaded asynchronously, so we need to wait for them to be available
    // before initializing the widgets.
    // We clear the interval after 10 seconds to prevent memory leaks.
    const interval = setInterval(() => {
      if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        window.yotpoWidgetsContainer.initWidgets();
        clearInterval(interval);
      }
    }, 100);

    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 10000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="md:max-w-[50%] md:basis-[50%] md:pr-15 l:max-w-[40%] l:basis-[40%] l:pl-0 l:pr-20 lg:pr-[calc(40%-447px)]">
      <div className="px-15 md:px-0">
        {category && (
          <span className="category leading-20 mb-4 block font-franklin text-16 text-secondary">{category}</span>
        )}
        <h1 className="h3 text-primary md:mb-4">{title}</h1>
        {linkedCollection && (
          <a
            className="body-12-light l:body-14-light mb-8 inline-block underline md:mb-4"
            href={`/collections/${linkedCollection.handle}`}
          >
            {linkedCollection.title}
          </a>
        )}
        <div
          className="yotpo-widget-instance"
          data-yotpo-instance-id={starRatingID}
          data-yotpo-product-id={props.product.idClean}
          data-yotpo-section-id="product"
        ></div>
      </div>
      <div className="product-form mt-8 md:mt-12">
        {props.isBundle ? (
          <BundleForm {...props} />
        ) : (
          <Fragment>
            <ProductForm
              openCustomizerStyleModal={openCustomizerStyleModal}
              {...props}
            />
          </Fragment>
        )}
      </div>
    </div>
  );
};

// exports
export default ProductDetail;
